<template>
  <v-content>
    <v-container fill-height fluid>
        <!--this.setSigningIn(false)-->
        <v-row>
          <v-col cols="12" align="center"
                 justify="center"
                 class="grey lighten-5">
            <BaseCard v-if="$store.state.signingin" height="400" max-width="400">
              <VCardText>
                <v-container fill-height>
                  <!--this.setSigningIn(false)-->
                  <v-row>
                    <v-col cols="12">Logging in</v-col>
                    <v-col cols="12" align="center"
                           justify="center" class="pt-10">
                      <img :src="require('@/assets/bigpreloader.png')" height="180" width="180" class="preloader"  />
                    </v-col>
                  </v-row>
                </v-container>
              </VCardText>
            </BaseCard>

            <BaseCard v-else   max-width="400">
              <VCardTitle class="title font-weight-light">
                <v-avatar tile size="40" class="mr-2">
                  <img :src="require('@/assets/mstile-150x150.png')" />
                </v-avatar>
                Sign In
              </VCardTitle>

              <VCardText v-if="message">{{message}}</VCardText>


              <VCardText>
                <UserName />
                <Password  />
              </VCardText>

              <VCardActions>
                <BaseBtn  text  to="/auth/signup" >
                  Sign Up
                </BaseBtn>
                <VSpacer/>
                <BaseBtn  text  to="/auth/forgotpassword">
                  Forgot Password ?
                </BaseBtn>
                <VSpacer/>
                <BaseBtn  text  to="/" >
                  Home
                </BaseBtn>
              </VCardActions>

            </BaseCard>

          </v-col>

        </v-row>
    </v-container>
  </v-content>
</template>

<script>
  import BaseBtn from "../../components/BaseBtn";
  export default {
    components: {
      BaseBtn,
      UserName: () => import('@/views/auth/UserName'),
      Password: () => import('@/views/auth/Password')
    },
    data: () => ({
      model: 0,
      message: undefined
    }),
    mounted () {
      if(this.$route.query.redirect==='confirmed'){
        this.message = 'Your account is confirmed. Click to sign in'
      }
      if(this.$route.query.redirect==='notconfirmed'){
        this.message = 'Your account is not yet confirmed. Sign in to confirm...'
      }
      //let l = this.$store.getters['cognito/isLoggedIn'];
    },
  }
</script>

<style>
  .preloader {

    animation-name: spin;
    animation-duration: 5000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @keyframes spin {
    from {
      transform:rotate(0deg);
    }
    to {
      transform:rotate(360deg);
    }
  }
</style>
